import { Box, Paper } from '@mui/material'
import React from 'react'

function HomeCenterChat() {
  return (
    <div>
     <Box
      sx={{
        display: 'flex',
        // background:'black',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: 870,
          height: 630,
          borderRadius:4
          
        },
      }}
    >
     
      <Paper  elevation={3} >

        hum
      </Paper>
        </Box>
    </div>
  )
}

export default HomeCenterChat
